import {
  ExclamationCircleFilled,
  InfoCircleFilled,
  QuestionCircleOutlined,
  VerticalAlignTopOutlined
} from '@ant-design/icons'
import ImgBox from '@common/ImgBox'
import { corpImage } from '@components/Hotel/util'
import LoginSub from '@components/LocalMerchant/SiDa/Common/LoginSub'
import { dGet } from '@core/utils'
import {
  isWeddingDressPhotoProperty,
  isWeddingPlanProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import {
  getMerchantInfo,
  isSiDaMember,
  isSiDaTeam,
  isSiYiTeam,
  isStoreAccount
} from '@util'
import { Flex, Select, Tooltip } from 'hljd'
import React from 'react'
import { Link } from 'react-router'
import store from '../../../store'
import style from './index.module.less'

const Option = Select.Option

export default () => {
  return [
    {
      title: '案例标题',
      dataIndex: 'name',
      key: 'name',
      width: 360,
      render: (text, record) => {
        let {
          merchant,
          is_sold_out,
          vertical_image,
          cover_path,
          status,
          dream_tag,
          certified,
          is_set_area,
          sensitive_tip,
          normative_notice,
          consult_case
        } = record
        merchant = merchant || {}
        const isSelfPublish = merchant.id == getMerchantInfo().id
        const src =
          vertical_image ||
          cover_path ||
          'https://qnm.hunliji.com/Fkgr3Q93xWK3MLJrSS24vgA3Cjpo?imageView2/1/w/288/h/288'

        let info = ''

        // 如果已下架状态，则不显示审核状态
        if (is_sold_out && !!store.title_search) {
          info = '已下架'
        }

        info =
          info || (status == 0 ? '审核中' : status == 3 ? '审核未通过' : '')

        return (
          <div className={style.titleContainer}>
            <div className={style.nameWrap}>
              <div style={{ position: 'relative' }}>
                <ImgBox
                  imgs={corpImage(src, '1:1', 500)}
                  imgH={72}
                  imgW={72}
                  onPreview={vertical_image || cover_path ? null : () => {}}
                  title={info ? <div className={style.shadow}>{info}</div> : ''}
                />
              </div>
              <div className={style.name}>
                <h5 className="text-cut-multiline">
                  {record.status == 3 || record.is_sold_out == true ? (
                    <a>{record.title}</a>
                  ) : (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      // eslint-disable-next-line
                      href={`${__HUNLIJI_DOMAIN__}/example/detail_${record.id}`}
                    >
                      {record.title}
                    </a>
                  )}
                </h5>
                <div className={style.labelWrap}>
                  {isWeddingPlanProperty() &&
                    certified == 1 && (
                      <div className={style.validTag}>实例认证</div>
                    )}
                  {consult_case && (
                    <Tooltip
                      placement="topLeft"
                      arrowPointAtCenter
                      title={
                        consult_case?.is_expired == '1'
                          ? `该参考案例已于 ${
                              consult_case?.expired_at
                            } 自动下架`
                          : `该参考案例将于 ${
                              consult_case?.expired_at
                            } 自动下架`
                      }
                    >
                      <div className={style.validTag}>参考案例</div>
                    </Tooltip>
                  )}
                  {record.is_special == 1 && (
                    <span className={style.validTag}>
                      主店铺
                      <Tooltip
                        placement="topLeft"
                        title="该案例无法直接编辑，系统将自动同步主店铺的案例更新"
                      >
                        <QuestionCircleOutlined
                          style={{ cursor: 'pointer', marginLeft: 2 }}
                        />
                      </Tooltip>
                    </span>
                  )}
                  {record.source == 1 && (
                    <span className={style.validTag}>水镜</span>
                  )}
                  {dream_tag == 1 && (
                    <div className={style.dreamTag}>喜橙婚礼</div>
                  )}
                </div>
                {isSiDaTeam() &&
                  !isSelfPublish &&
                  !isSiYiTeam() &&
                  !(
                    <LoginSub
                      style={{
                        color: '#448afc',
                        fontSize: '12px',
                        lineHeight: 1,
                        display: 'block',
                        marginTop: 6
                      }}
                      storeId={merchant.m_store_id}
                    >
                      {dGet(record, 'merchant.name')}
                    </LoginSub>
                  )}
              </div>
            </div>
            {sensitive_tip && (
              <Flex
                style={{
                  fontSize: 12,
                  color: '#FF4B4B'
                }}
              >
                <ExclamationCircleFilled
                  style={{
                    lineHeight: 2,
                    color: '#FF4B4B',
                    fontSize: 12,
                    marginRight: 4
                  }}
                />
                <p style={{ lineHeight: '22px' }}>{sensitive_tip}</p>
              </Flex>
            )}
            {normative_notice ? (
              <p style={{ width: 460 }}>
                <InfoCircleFilled
                  style={{ color: '#ff4b4b', marginRight: 6 }}
                />
                {normative_notice}
              </p>
            ) : (
              <>
                {/* 未分区图片设置提示 */}
                {is_set_area == 0 &&
                  !is_sold_out && (
                    <div className={style.noSettingArea}>
                      <ExclamationCircleFilled
                        style={{
                          lineHeight: '12px',
                          color: '#F78F36',
                          fontSize: 12,
                          marginRight: 4
                        }}
                      />
                      <span>
                        案例图片未设置区域，为避免影响成交转化，请及时处理
                      </span>
                    </div>
                  )}
              </>
            )}
          </div>
        )
      }
    },
    {
      title: '成员',
      dataIndex: 'emcee_member',
      render: (text, record) => <div>{record?.emcee_member?.name}</div>,
      hidden: () => !isSiYiTeam()
    },
    {
      title: '类型',
      dataIndex: 'meal_type',
      render: meal_type => (meal_type == 1 ? '样片' : '客照'),
      hidden: () => !isWeddingDressPhotoProperty()
    },
    {
      title: '收藏量',
      dataIndex: 'num',
      align: 'right',
      render: (text, record) => (
        <div>
          {'' + record.collectors_count ? record.collectors_count : '-'}
        </div>
      )
    },
    {
      title: (
        <span>
          点击率&nbsp;
          <Tooltip
            placement="topLeft"
            title="点击率=案例的点击次数/案例的曝光量x100%"
          >
            <QuestionCircleOutlined style={{ color: '#aaaaaa' }} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'ctr_uv',
      align: 'right',
      key: 'ctr_uv',
      sorter: !store.isSort,
      sortOrder: store.$sorter.columnKey === 'ctr_uv' && store.$sorter.order,
      sortDirections: ['descend', 'ascend'],
      render: text => {
        if (!text) {
          return '-'
        } else {
          return (text * 100).toFixed(2) + '%'
        }
      }
    },
    {
      title: '分类',
      key: 'merchant_category',
      hidden: isSiDaMember(),
      render: (m, record) => {
        const { id, meal_type } = record
        const merchant_category = record.merchant_category || {}
        return (
          <Select
            value={merchant_category.id || undefined}
            onChange={value => store.selectChange(id, meal_type, value)}
            style={{ width: 110 }}
            placeholder="请选择分类"
          >
            {store.categoryList.map(item => {
              return (
                <Option value={item.id} key={item.id}>
                  {item.title}
                </Option>
              )
            })}
          </Select>
        )
      }
    },
    {
      title: (
        <span>
          关联客照&nbsp;
          <a href="#/localMerchant/case/introduce" style={{ color: '#ff8c30' }}>
            <QuestionCircleOutlined />
          </a>
        </span>
      ),
      dataIndex: 'sample_related_pic_count',
      render: (text, record) => {
        return record.meal_type == 1 ? (
          <Link to={'/localMerchant/case/unionPhoto/' + record.id}>
            已关联{text || '0'}张
          </Link>
        ) : (
          <span>-</span>
        )
      },
      hidden: () => {
        if (isStoreAccount()) {
          return +store.currentProperty !== 6
        } else {
          return !isWeddingDressPhotoProperty()
        }
      }
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      render: (text, record) => <div>{record.created_at}</div>
    },
    {
      title: '操作',
      dataIndex: 'edit',
      render: (
        text,
        record, //第一个tab和最后一个tab分上架下架，其他根据is_sold_out判断
        index
      ) => {
        if (isWeddingRingJewelryProperty()) {
          return (
            <p className={style.aFlag}>
              <a
                href={`#/localMerchant/publish?type=0&id=${record.id}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={event => event.target.classList.add('clicked')}
              >
                发布为动态
              </a>
            </p>
          )
        }

        if (store.isSort) {
          return (
            <div className={style.settingColumn}>
              <p
                className={index != 0 ? style.toTop : ''}
                onClick={() => store.toTop(index)}
              >
                <VerticalAlignTopOutlined />置顶
              </p>
              <p>拖动可排序</p>
            </div>
          )
        }

        // 四大团队成员的案例
        const isSiDaMemberCase =
          isSiDaTeam() && getMerchantInfo().id != dGet(record, 'merchant.id')
        return (
          <>
            {record.is_special == 1 ? ( //同步模式，从主张号复制过来的
              <p>
                <a
                  style={{ color: '#508cee' }}
                  onClick={store.showModalMove(
                    record.id,
                    1,
                    record.is_in_brand
                  )}
                >
                  移除
                </a>
              </p>
            ) : (
              <>
                {
                  <>
                    {!isSiDaMemberCase && (
                      <p>
                        <a
                          style={{ color: '#508cee' }}
                          onClick={store.toEdit(record)}
                        >
                          编辑
                        </a>
                      </p>
                    )}

                    <p>
                      <a
                        style={{ color: '#508cee' }}
                        onClick={store.showModalFn(
                          record.id,
                          record.is_sold_out,
                          1,
                          record.is_in_brand,
                          record
                        )}
                      >
                        {record.is_sold_out == true
                          ? '上架'
                          : record.is_sold_out == false ||
                            record.is_sold_out == null
                            ? '下架'
                            : ''}
                      </a>
                    </p>
                  </>
                }
              </>
            )}
          </>
        )
      }
    }
  ]
}
